import { DprForecastActivityGridData } from '@dpr-details/models/grid';
import { WriteDprForecastActivity } from '@dpr-details/models/sync';
import { DprForecastActivity } from '@shared/models/dpr';
import { Sync } from '@shared/models/grid';

export function mapForecastActivitiesToForecastGridData(
  forecastActivity: DprForecastActivity | WriteDprForecastActivity
): DprForecastActivityGridData {
  const date = new Date(forecastActivity.date).toISOString().split('T')[0];
  return {
    ...forecastActivity,
    date,
  };
}

export function mapSyncForecastActivitiesToSyncForecastGridData(
  forecastActivity: Sync<DprForecastActivity | WriteDprForecastActivity>
): Sync<DprForecastActivityGridData> {
  if (!forecastActivity) {
    return null;
  }
  return {
    addedList: forecastActivity.addedList.map((x) =>
      mapForecastActivitiesToForecastGridData(x)
    ),
    updatedList: forecastActivity.updatedList.map((x) =>
      mapForecastActivitiesToForecastGridData(x)
    ),
    deletedIds: forecastActivity.deletedIds,
  };
}
